/***
 * 姓名 :D
 * 创建时间:2019-3-8
 * 描述：初始化方法服务
 * 更新记录: 
 */
 import { Injectable } from '@angular/core';
 import { SwHttpClientService } from './sw-http-client.service';
 import { environment } from 'src/environments/environment';
 import { SwJwtService } from './sw-jwt.service';
 import { ProcessToDosService } from './public/process-to-dos.service';
 import { SwSimpleReuseStrategy } from 'src/app/librarys/serves/sw-simplereusestrategy';
 import { SwRouteguardService } from 'src/app/librarys/serves/sw-routeguard.service';
 import { LazyDashboardTitleModules } from './lazy-dashboard-title-modules.service';
 import { SystemIdService } from './public/system-id.service';
 @Injectable()
 export class OninitService {
 
   constructor(
     private http: SwHttpClientService, //请求服务
     private jwt: SwJwtService, //获取浏览器缓存 
     private systemid: SystemIdService,  //系统id的服务
     private lazyService: LazyDashboardTitleModules, //初始化加载模块
     private process: ProcessToDosService,   //初始化流程
     private swRouter: SwRouteguardService, //路由守卫地址
   ) {
   }
   //设置字典到缓存
   inItDictionary() {
     //两种模式，看是否配置了分模块加载字典项
     if (environment["defaultDictionary"]!=null) {
 
       //如果系统的id改变了
       this.systemid.systemIdUpdated.subscribe(data => {
         let userInfo = JSON.parse(this.jwt.getToken("User"));
         let systemId = this.systemid.getSystemId();
         let systemCode = userInfo.systems.filter(x => x.systemId == systemId)[0].systemCode;  //从缓存中得到当前用户system的code信息
         if (environment["defaultDictionary"] == "") {
           //不填写的话则默认取SYS,写了的话则按照写的模块名取字典
           //从用户的system中取得systemCode
           let urlBasic=environment.seekerWebAPI;
 
           //略过，默认加载了
           this.http.Post(urlBasic+"common/queryDictCacheByPrefix?systemCode=" + systemCode,["SYS"]).subscribe(data => {
             if (data["code"] == 200) {
               //先关闭加载层
               this.jwt.setToKen("LoadedDictionary", "SYS|");
               this.jwt.setToKen("dictionary", JSON.stringify(data["data"]));
             }
           })
         } else {
           let moduleList = environment["defaultDictionary"].split("|");
           moduleList.forEach(x => {
             let urlBasic=environment[x.toLocaleLowerCase()+"WebAPI"];
             if(urlBasic){
               this.http.Post(urlBasic+"common/queryDictCacheByPrefix?systemCode=" + systemCode,[x]).subscribe(data => {
                 if (data["code"] == 200) {
                   //先关闭加载层
                   let LoadedDictionaryData=this.jwt.getToken("LoadedDictionary");
                   let dictionaryData=this.jwt.getToken("dictionary");
                   if(LoadedDictionaryData){
                     LoadedDictionaryData+= x+"|";
                     this.jwt.setToKen("LoadedDictionary",LoadedDictionaryData);
                     this.jwt.setToKen("dictionary", JSON.stringify([...JSON.parse(dictionaryData),...data["data"]]));
                   }else{
                     LoadedDictionaryData= x+"|";
                     this.jwt.setToKen("LoadedDictionary",LoadedDictionaryData);
                     this.jwt.setToKen("dictionary", JSON.stringify([...data["data"]]));
                   }               
                 }
               })
             }
           })
         }
       })
 
 
       let userInfo = JSON.parse(this.jwt.getToken("User"));
       let systemId = this.systemid.getSystemId();
       let systemCode = userInfo.systems.filter(x => x.systemId == systemId)[0].systemCode;  //从缓存中得到当前用户system的code信息
 
       if(this.jwt.getToken("LoadedDictionary")!=null){
           //说明有，是刷新操作，不必重新取
           return false;
       }
       //存在的话，则按模块取
       if (environment["defaultDictionary"] == "") {
         //不填写的话则默认取SYS,写了的话则按照写的模块名取字典
         //从用户的system中取得systemCode
         let urlBasic=environment.seekerWebAPI;
 
         //略过，默认加载了
         
         this.http.Post(urlBasic+"common/queryDictCacheByPrefix?systemCode=" + systemCode,["SYS"]).subscribe(data => {
           if (data["code"] == 200) {
             //先关闭加载层
             this.jwt.setToKen("LoadedDictionary", "SYS|");
             this.jwt.setToKen("dictionary", JSON.stringify(data["data"]));
           }
         })
       } else {
         let moduleList = environment["defaultDictionary"].split("|");
         moduleList.forEach(x => {
           //转化成小写
           let urlBasic=environment[x.toLocaleLowerCase()+"WebAPI"];
           if(!urlBasic){
             urlBasic="";
             return false;
           }
           
           this.http.Post(urlBasic+"common/queryDictCacheByPrefix?systemCode=" + systemCode,[x]).subscribe(data => {
             if (data["code"] == 200) {
               //先关闭加载层
               let LoadedDictionaryData=this.jwt.getToken("LoadedDictionary");
               let dictionaryData=this.jwt.getToken("dictionary");
               if(LoadedDictionaryData){
                 LoadedDictionaryData+= x+"|";
                 this.jwt.setToKen("LoadedDictionary",LoadedDictionaryData);
                 this.jwt.setToKen("dictionary", JSON.stringify([...JSON.parse(dictionaryData),...data["data"]]));
               }else{
                 LoadedDictionaryData= x+"|";
                 this.jwt.setToKen("LoadedDictionary",LoadedDictionaryData);
                 this.jwt.setToKen("dictionary", JSON.stringify([...data["data"]]));
               }               
             }
           })
         })
       }
     } else {
       //如果系统的id改变了
       this.systemid.systemIdUpdated.subscribe(data => {
         let params = { "param": { pageSize: 0 }, "entity": { systemId: this.systemid.getSystemId() } }
         //重新获取字典数据
         this.http.Post(environment.seekerWebAPI + "dictionary/queryPageList", params).subscribe(data => {
           if (data["code"] == 200) {
             //将字典数据存到本地缓存中去
             this.jwt.setToKen("dictionary", JSON.stringify(data["data"]["records"]))
           }
         });
       })
       //最开始触发该方法时,获取字典值,存入本地缓存
       let params = { "param": { pageSize: 0 }, "entity": { systemId: this.systemid.getSystemId() } }
       this.http.Post(environment.seekerWebAPI + "dictionary/queryPageList", params).subscribe(data => {
         if (data["code"] == 200) {
           this.jwt.setToKen("dictionary", JSON.stringify(data["data"]["records"]))
         }
       });
     }
     
     //获取场馆列表
     this.queryCompanyInfo()
   }
 
   //主动触发请求字典数据
   activeInItDictionary(): Promise<void> {
    //两种模式，看是否配置了分模块加载字典项
    if (environment["defaultDictionary"]!=null) {

      let userInfo = JSON.parse(this.jwt.getToken("User"));
      let systemId = this.systemid.getSystemId();
      let systemCode = userInfo.systems.filter(x => x.systemId == systemId)[0].systemCode;  //从缓存中得到当前用户system的code信息

      if(this.jwt.getToken("LoadedDictionary")!=null){
          //说明有，是刷新操作，不必重新取
          return new Promise((resolve) => { 
            resolve();
         })
      }
      //存在的话，则按模块取
      if (environment["defaultDictionary"] == "") {
        //不填写的话则默认取SYS,写了的话则按照写的模块名取字典
        //从用户的system中取得systemCode
        let urlBasic=environment.seekerWebAPI;

        //略过，默认加载了
        
       return new Promise((resolve) => { 
         this.http.Post(urlBasic+"common/queryDictCacheByPrefix?systemCode=" + systemCode,["SYS"]).subscribe(data => {
          if (data["code"] == 200) {
            //先关闭加载层
            this.jwt.setToKen("LoadedDictionary", "SYS|");
            this.jwt.setToKen("dictionary", JSON.stringify(data["data"]));
            resolve();
          }
        })
      })
      } else {
        let moduleList = environment["defaultDictionary"].split("|");
        moduleList.forEach(x => {
          //转化成小写
          let urlBasic=environment[x.toLocaleLowerCase()+"WebAPI"];
          if(!urlBasic){
            urlBasic="";
            return false;
          }
          
          return new Promise((resolve) => {   
            this.http.Post(urlBasic+"common/queryDictCacheByPrefix?systemCode=" + systemCode,[x]).subscribe(data => {
            if (data["code"] == 200) {
              
              //先关闭加载层
              let LoadedDictionaryData=this.jwt.getToken("LoadedDictionary");
              let dictionaryData=this.jwt.getToken("dictionary");
              if(LoadedDictionaryData){
                LoadedDictionaryData+= x+"|";
                this.jwt.setToKen("LoadedDictionary",LoadedDictionaryData);
                this.jwt.setToKen("dictionary", JSON.stringify([...JSON.parse(dictionaryData),...data["data"]]));
              }else{
                LoadedDictionaryData= x+"|";
                this.jwt.setToKen("LoadedDictionary",LoadedDictionaryData);
                this.jwt.setToKen("dictionary", JSON.stringify([...data["data"]]));
              }   
              
              resolve(true);
            }
          })

        })

        })
      }
    } else {
      //最开始触发该方法时,获取字典值,存入本地缓存
      let params = { "param": { pageSize: 0 }, "entity": { systemId: this.systemid.getSystemId() } }
      return new Promise((resolve) => {  this.http.Post(environment.seekerWebAPI + "dictionary/queryPageList", params).subscribe(data => {
        if (data["code"] == 200) {
          this.jwt.setToKen("dictionary", JSON.stringify(data["data"]["records"]))
          resolve();
        }
      });
    })
    }
    
    //获取场馆列表
    this.queryCompanyInfo()
  }

   //改变皮肤
   changeColor(bodyDom, item) {
     let bodyClass = bodyDom.classList
     //移除之前的皮肤
     bodyClass.forEach(skin => {
       if (skin.indexOf('skin') != -1) {
         bodyDom.classList.remove(skin)
       }
     });
     bodyDom.classList.add(item.className)
     //将皮肤颜色缓存
     this.jwt.setlocaToken('skinColor', item.className)
   }
 
   //初始化待办
   inItToDos() {
     this.process.oninitProcessToDos();
   }
 
   //初始化通知
   inItNoitec() {
     // this.process.oninitNotice();
   }
 
 
   loca(modules: any) {
     this.lazyService.load(modules)
   }
 
   //清除缓存，工作台和路由复用
   GC() {
     this.jwt.clear(); //清除浏览器缓存数据
     this.swRouter.clear(); //清除工作台
     this.systemid.setSystemId('')
     SwSimpleReuseStrategy.deleteAllRouteSnapshot();// 删除所有路由复用
   }
 
 
   //初始化systemid
   setSystem() {
     this.systemid.setSystemId(this.jwt.getToken("systemId"))
     //this.systemid.systemIdUpdated.next(this.jwt.getToken("systemId"));
   }
 
   //获取场馆列表
   queryCompanyInfo(){
     //如果系统的id改变了
     this.systemid.systemIdUpdated.subscribe(data => {
       let param = {
         systemId: this.systemid.getSystemId()
       }
       this.http.Post(environment.saasWebAPI + "companyInfo/queryCompanyInfoPageList", param).subscribe(data => {
         if (data["code"] == 200) {
           //将字典数据存到本地缓存中去
           let dat = data["data"]["records"]
           dat.forEach(el=>{
             el.id = el.companyInfoId
             el.text = el.companyName
           })
           this.jwt.setToKen("companyInfo", JSON.stringify(dat))
         }
       });
     })
 
     let systemId = this.systemid.getSystemId();
     let param = {
       systemId:systemId
     }
     this.http.Post(environment.saasWebAPI + "companyInfo/queryCompanyInfoPageList", param).subscribe(data => {
       if (data["code"] == 200) {
         //将字典数据存到本地缓存中去
         let dat = data["data"]["records"]
         dat.forEach(el=>{
           el.id = el.companyInfoId
           el.text = el.companyName
         })
         this.jwt.setToKen("companyInfo", JSON.stringify(dat))
       }
     });
   }
 
 
 
 }
 